import * as React from 'react';
import { SettingsSection } from '../../../../../../base/components/SettingsSection/SettingsSection';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { CLASS_BOARD_DETAILS_SECTION } from '../../../../constants';
import { ITagsSectionProps } from './types';
import { BoardTagsHOC } from '../../hocs/BoardTagsHOC/BoardTagsHOC';
import { BOARD_SECTION_TAGS } from '../../constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';
import { TutorialHOC } from '../../../Tutorial/hocs/TutorialHOC/TutorialHOC';

export function TagsSection ({
}: ITagsSectionProps) {
    const { boardId } = React.useContext(AsidePanelContext);
    const className = CLASS_BOARD_DETAILS_SECTION + ' ' + CLASS_BOARD_DETAILS_SECTION + '--tags';

    return (
        <>
            <TutorialHOC boardSetting={EBoardSetting.TAGS} />
            <SettingsSection
                className={className}
                title={BOARD_SECTION_TAGS}
            >
                <BoardTagsHOC
                    boardId={boardId}
                />
            </SettingsSection>
        </>
    );
};
